const LOCAL_GRPC = "http://localhost:8080";
export const PRODUCTION_GRPC = "https://api.balabalabom.com";

function currentHostname(): string {
  if (typeof window === "undefined") return "";
  return window.location.hostname;
}

function isProductionBrandHost(hostname: string): boolean {
  const host = hostname.trim().toLowerCase();
  return host === "balabalabom.com" || host.endsWith(".balabalabom.com");
}

/**
 * Resolve the gRPC-Web backend.
 * Env wins (local .env / Netlify). If a production kids/store build was
 * shipped without REACT_APP_GRPC_WEB_URL, fall back to api.balabalabom.com
 * instead of localhost — that miss produces HTTP status 0 in the browser.
 */
export function resolveGrpcEndpoint(
  envUrl: string | undefined,
  hostname: string
): string {
  const fromEnv = envUrl?.trim();
  if (fromEnv) return fromEnv.replace(/\/+$/, "");
  if (isProductionBrandHost(hostname)) return PRODUCTION_GRPC;
  return LOCAL_GRPC;
}

export function getGrpcEndpoint(): string {
  return resolveGrpcEndpoint(
    process.env.REACT_APP_GRPC_WEB_URL || process.env.REACT_APP_API_URL,
    currentHostname()
  );
}
